export enum SuspendedReasonEnum {
    TrainerFreeze = 1,
    TrainerTechnicalDifficulty = 2
}